/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API,
};
export default {
    //学习课程类别
  category: {
      query:`${base.url}/other/learn/category/list`,
      addOrUpdate: `${base.url}/other/learn/category/save`,
      deleteBatchId: `${base.url}/other/learn/category/update`,
      all:  `${base.url}/other/learn/category/listAll`,
    },

  //学习课程文章
  article: {
    query:`${base.url}/other/learn/article/list`,
    addOrUpdate: `${base.url}/other/learn/article/save`,
    deleteBatchId: `${base.url}/other/learn/article/del`,
  },
  //学习课程文章
  practice: {
    query:`${base.url}/other/learn/practice/list`,
    addOrUpdate: `${base.url}/other/learn/practice/save`,
    deleteBatchId: `${base.url}/other/learn/practice/del`,
  },

  //学习课程文章
  examPractice: {
    query:`${base.url}/other/exam/practice/list`,
    addOrUpdate: `${base.url}/other/exam/practice/save`,
    deleteBatchId: `${base.url}/other/exam/practice/del`,
  },

  topic:{
    query:`${base.url}/other/topic/list`,
    addOrUpdate: `${base.url}/other/topic/save`,
    deleteBatchId: `${base.url}/other/topic/del`,
    all: `${base.url}/other/topic/findByNameList`,
  },
  topicUser:{
    query:`${base.url}/other/topicUser/list`,
    addOrUpdate: `${base.url}/other/topicUser/save`,
    update: `${base.url}/other/topicUser/update`,
    batchUpdate: `${base.url}/other/topicUser/batchUpdate`,
    downloadTopicComments: `${base.url}/other/topicUser/downloadTopicComments`,
  },

  wealthArticle:{
    query:`${base.url}/other/wealthArticle/list`,
    addOrUpdate: `${base.url}/other/wealthArticle/save`,
    deleteBatchId: `${base.url}/other/wealthArticle/del`,
    update: `${base.url}/other/wealthArticle/update`,
  },

  wealthComment:{
    query:`${base.url}/other/wealthComment/list`,
    addOrUpdate: `${base.url}/other/wealthComment/save`,
    deleteBatchId: `${base.url}/other/wealthComment/del`,
    update: `${base.url}/other/wealthComment/update`,
    statistical: `${base.url}/other/wealthComment/statistical`,
  },
//上传图片
  img:{
    upload:`${base.url}/cloud/file/uploadImage`,

  },
  question:{
    type:{
      list:`${base.url}/other/questionType/list`,
      codeList:`${base.url}/other/questionType/codeList`,
      update:`${base.url}/other/questionType/update`,
      delete:`${base.url}/other/questionType/delete`,
    },
    content:{
      list:`${base.url}/other/questionContent/list`,
      update:`${base.url}/other/questionContent/update`,
      delete:`${base.url}/other/questionContent/delete`,
    }
  }

};


